import axios from 'axios';
import qs from 'qs';

export const getTheoryLessonById = ({
  lessonId,
  locale,
}: {
  lessonId: string;
  locale?: string;
}) =>
  axios.get(
    `/api/v1/theory-lessons/${lessonId}${locale ? `?${qs.stringify({ locale })}` : ''}`,
  );

export const createTheoryLesson = (data: any) =>
  axios.post('/api/v1/theory-lessons', data);

export const updateTheoryLessonById = ({
  lessonId,
  data,
}: {
  lessonId: string;
  data: any;
}) => axios.put(`/api/v1/theory-lessons/${lessonId}`, data);

export const removeTheoryLessonById = (lessonId: string) =>
  axios.delete(`/api/v1/theory-lessons/${lessonId}`);
